import React from 'react';
import _ from "lodash";
import { Component, Container, PuzzleButton, PuzzleTabStrip } from "puzzle";
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from "@progress/kendo-react-layout";

type PROPS = {
  backgroundEnabled: boolean
  instructionsEnabled: boolean
  instructions: string
  background: string
  phaseType: string
  submissionId: number
};
type STATE = {
  selected: number
};

class InstructionsAndNotes extends Component<PROPS, STATE> {
  instructionsTabStripRef: any;

  public state: STATE = {
    selected: 0
  }

  /**
   * Download instructions button handler
   */
  downloadInstructions = () => {
    const url = `/submissions/${this.props.submissionId}/downloadInstructions?phaseType=${this.props.phaseType}`;
    this.dispatch('downloadInstructions', '', { url });
  };

  /**
   * Changes from instructions to notes and vice versa on click
   * @param e
   */
  onInstructionsTabStripChange = (e: TabStripSelectEventArguments) => {
    this.setState({ selected: e.selected });
  }

  /**
   * Render for the empty sections when there are no instruction/documents
   * @param name  name of the section
   */
  emptySectionRender = (name?: string) => {
    let translateLabel = this.translate('emptyDocumentsSectionLabelTask');

    if (name === 'instructions') {
      translateLabel = this.translate('emptyInstructionsSectionLabel');
    }

    if (name === 'notes') {
      translateLabel = this.translate('emptyNotesSectionLabel');
    }

    let imgClass: string = 'tp-grid-empty-state-img no-instructions'
    if (!_.includes(['instructions', 'notes'], name)) {
      imgClass = 'tp-grid-empty-state-img no-documents';
    }

    return (
      <Container vBox alignItemsCenter justifyContentCenter
                 className={`tp-empty-section-info ${name === 'documents' ? 'documents' : ''}`}>
        <div aria-hidden="true" className={imgClass} />
        <span className="tp-empty-section-info-text tp-text-semibold k-text-center">{translateLabel}</span>
      </Container>
    );
  }


  /**
   * Renders instructions, notes text or icon if text does not exist
   * @param notesTab
   */
  renderInstructionsAndNotes = (notesTab: boolean) => {
    const { instructions, background } = this.props;
    let textToRender: string = instructions || "<p></p>";
    let emptySectionRender: string = 'instructions';
    if (notesTab) {
      textToRender = background || "<p></p>";
      emptySectionRender = 'notes';
    }

    let notesAndInstructionsRender: JSX.Element | null = null;
    notesAndInstructionsRender = (textToRender !== "<p></p>") ?
      <>
        <PuzzleButton
          aria-label={this.translate('SRL-downloadInstructions')}
          fillMode='flat'
          size={'small'}
          themeColor={'primary'}
          iconClass="tp-icon tp-icon-md tp-download"
          className='tp-header-button'
          onClick={this.downloadInstructions}
        />
        <div dangerouslySetInnerHTML={{ __html: textToRender }} />
      </>
      : this.emptySectionRender(`${emptySectionRender}`)

    return (
      notesAndInstructionsRender
    )
  }

  renderBody = () => {
    const { backgroundEnabled, instructionsEnabled } = this.props;
    let tabCount = 2;
    if (!(backgroundEnabled && instructionsEnabled)) {
      tabCount = 1;
    }

    return (
      <PuzzleTabStrip
        ref={(tabStrip: any) => this.instructionsTabStripRef = tabStrip}
        handleSelect={this.onInstructionsTabStripChange}
        tabCount={tabCount}
        translate={this.translate}
        selected={this.state.selected}
      >
        <TabStrip
          selected={this.state.selected}
        >
          {instructionsEnabled && <TabStripTab
            key={"instructions"}
            title={this.translate("instructions")}
            contentClassName="tp-no-border"
          >
            {this.renderInstructionsAndNotes(false)}
          </TabStripTab>}
          {backgroundEnabled && <TabStripTab
            key={"notes"}
            title={this.translate("notes")}
            contentClassName="tp-no-border"
          >
            {this.renderInstructionsAndNotes(true)}
          </TabStripTab>}
        </TabStrip>
      </PuzzleTabStrip>
    );
  }
}

export default InstructionsAndNotes;
